import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';
import { twelveHourUserSettingsNoTimeZone, twelveHourUserSetting } from '../../../../../constants/timezone-format';

import { useUITimeFormatSetting } from '../../../../../hooks/use-user-setting';

import TimePicker from './time-picker';

import notificationConfigurationPropType from './notification-configuration-prop-types';

import messages from '../messages';
import style from '../style.module.less';
import { emptyObject } from 'ui-components/default-props/empty';

const defaultTime = '4:30PM';
const SpecificTimeCheckbox = ({ config = emptyObject, disabled = true, updateConfig }) => {
  const { trackOnTimeStampString } = config;
  const userTimeFormat = useUITimeFormatSetting();
  const formatToUse = userTimeFormat === twelveHourUserSetting ? twelveHourUserSettingsNoTimeZone : userTimeFormat;

  const onDropdownChange = useCallback(
    (id, value) => {
      updateConfig(value, id);
    },
    [updateConfig],
  );

  const onCheckboxChange = useCallback(
    (checked) => {
      const defaultOrExistingSetting = trackOnTimeStampString?.length ? trackOnTimeStampString : defaultTime;
      const value = checked ? defaultOrExistingSetting : '';
      updateConfig(value, 'trackOnTimeStampString');
    },
    [updateConfig, trackOnTimeStampString],
  );

  return (
    <>
      <Checkbox
        checked={!!trackOnTimeStampString}
        className={style.checkbox}
        disabled={disabled}
        label={<FormattedMessage {...messages.atSpecificTime} />}
        onChange={onCheckboxChange}
      />
      {!!trackOnTimeStampString && !disabled && (
        <div className={style['sub-field']}>
          <TimePicker
            id='trackOnTimeStampString'
            onTimeSelected={onDropdownChange}
            selectedValue={trackOnTimeStampString.toUpperCase()}
            timeFormat={formatToUse}
          />
          <FormattedMessage
            {...messages.atSpecificTimeAdditionalInfo}
            values={{
              a: (chunks) => <Link to='/settings/displayoptions'>{chunks}</Link>,
            }}
          >
            {(translation) => <div className={style['sub-input-description']}>{translation}</div>}
          </FormattedMessage>
        </div>
      )}
    </>
  );
};

SpecificTimeCheckbox.propTypes = {
  config: notificationConfigurationPropType,
  disabled: PropTypes.bool,
  updateConfig: PropTypes.func.isRequired,
};

export default SpecificTimeCheckbox;
